import { cn } from "@/lib/utils"

export const DIAL_ROWS: { digit: string; letters?: string }[][] = [
  [{ digit: "1" }, { digit: "2", letters: "ABC" }, { digit: "3", letters: "DEF" }],
  [{ digit: "4", letters: "GHI" }, { digit: "5", letters: "JKL" }, { digit: "6", letters: "MNO" }],
  [
    { digit: "7", letters: "PQRS" },
    { digit: "8", letters: "TUV" },
    { digit: "9", letters: "WXYZ" },
  ],
  [{ digit: "*" }, { digit: "0" }, { digit: "#" }],
]

export const dialKeyClass =
  "flex h-[3.25rem] flex-col items-center justify-center rounded-xl border border-slate-200/90 bg-gradient-to-b from-white to-slate-50 text-slate-900 shadow-[0_1px_0_0_rgb(15_23_42/0.06),0_1px_2px_rgb(15_23_42/0.04)] transition-[transform,box-shadow,background-color] duration-150 hover:to-slate-100/90 active:scale-[0.97] active:shadow-inner dark:border-slate-600 dark:from-slate-800 dark:to-slate-900 dark:text-slate-100 dark:shadow-[0_1px_0_0_rgb(0_0_0/0.25)] dark:hover:to-slate-800"

export type TelephoneKeypadProps = {
  className?: string
  /** When true, * and # presses are ignored (phone number entry). */
  ignoreSpecialKeys?: boolean
  onDigitPress?: (digit: string) => void
}

export function TelephoneKeypad({
  className,
  ignoreSpecialKeys = false,
  onDigitPress,
}: TelephoneKeypadProps) {
  return (
    <div
      className={cn("grid grid-cols-3 gap-2", className)}
      role="group"
      aria-label="Telephone keypad"
    >
      {DIAL_ROWS.map((row, rowIndex) =>
        row.map(({ digit, letters }) => (
          <button
            key={`${rowIndex}-${digit}`}
            type="button"
            className={dialKeyClass}
            onClick={() => {
              if (ignoreSpecialKeys && (digit === "*" || digit === "#")) return
              onDigitPress?.(digit)
            }}
          >
            <span className="text-[1.125rem] font-semibold tabular-nums leading-none">
              {digit}
            </span>
            {letters ? (
              <span className="mt-0.5 text-[0.5625rem] font-medium tracking-[0.12em] text-slate-500 dark:text-slate-400">
                {letters}
              </span>
            ) : (
              <span className="mt-0.5 h-3" aria-hidden />
            )}
          </button>
        ))
      )}
    </div>
  )
}
